import GenericEvent from './genericEvent';
import EnemyEvent from './enemyEvent';
import ItemEvent from './itemEvent';

export default {
    EnemyEvent,
    GenericEvent,
    ItemEvent
};
